export default interface State {

}

export const initState: State = {

};
